import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    container: {
        marginBottom: 15,
    },
    sectionHeader: {
        fontSize: 16,
        color: '#004899',
        fontWeight: 'bold',
        marginBottom: 10,
        backgroundColor: '#f8f9fa',
        padding: 8,
        borderRadius: 4,
        borderLeftWidth: 3,
        borderLeftColor: '#004899',
    },
    card: {
        backgroundColor: '#ffffff',
        borderRadius: 6,
        padding: 12,
        borderWidth: 1,
        borderColor: '#e0e0e0',
        marginBottom: 10,
    },
    cardGrid: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    fieldGroup: {
        width: '50%',
        marginBottom: 8,
        paddingRight: 8,
    },
    fieldLabel: {
        fontSize: 10,
        color: '#666',
        marginBottom: 2,
        fontWeight: 'bold',
    },
    fieldValue: {
        fontSize: 11,
        color: '#333',
        backgroundColor: '#f7f7f7',
        padding: 6,
        borderRadius: 4,
        borderWidth: 1,
        borderColor: '#e0e0e0',
    },
    description: {
        width: '100%',
        marginBottom: 8,
    },
    descriptionValue: {
        fontSize: 11,
        color: '#333',
        backgroundColor: '#f7f7f7',
        padding: 6,
        borderRadius: 4,
        minHeight: 40,
        borderWidth: 1,
        borderColor: '#e0e0e0',
    },
});

interface ProjectDetailsSectionProps {
    projectDetails: {
        projectName: string;
        projectDescription: string;
        createdBy: string;
        createdAt: string;
        target?: string | number;
        plusByUser?: string | number;
        percentage?: string | number;
    };
}

export const NewProjectDetailsSection: React.FC<ProjectDetailsSectionProps> = ({ projectDetails }) => {
    const formattedDate = new Date(projectDetails.createdAt).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    return (
        <View style={styles.container}>
            <Text style={styles.sectionHeader}>Project Details</Text>

            <View style={styles.card}>
                <View style={styles.cardGrid}>
                    <View style={styles.fieldGroup}>
                        <Text style={styles.fieldLabel}>Project Name</Text>
                        <Text style={styles.fieldValue}>{projectDetails.projectName}</Text>
                    </View>

                    <View style={styles.fieldGroup}>
                        <Text style={styles.fieldLabel}>Created By</Text>
                        <Text style={styles.fieldValue}>{projectDetails.createdBy}</Text>
                    </View>

                    <View style={styles.fieldGroup}>
                        <Text style={styles.fieldLabel}>Created On</Text>
                        <Text style={styles.fieldValue}>{formattedDate}</Text>
                    </View>

                    <View style={styles.description}>
                        <Text style={styles.fieldLabel}>Description</Text>
                        <Text style={styles.descriptionValue}>{projectDetails.projectDescription}</Text>
                    </View>
                </View>
            </View>
        </View>
    );
}; 